import space from '@salesforce/retail-react-app/app/theme/foundations/space'
import {pxToRem} from '../../utills/pxToRem'
export default {
    ...space,
    2.5: pxToRem(10)
}
